import React from "react";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="terms">
      <h1>Terms of Service</h1>

      <h2>OVERVIEW</h2>
      <p>
        This website is operated by PIXEL GLOBAL MEDIA LIMITED under the autumncircle brand. Throughout the site, the terms
        “we”, “us” and “our” refer to autumncircle. autumncircle offers this website,
        including all information, tools and services available from this site
        to you, the user, conditioned upon your acceptance of all terms,
        conditions, policies and notices stated here.
      </p>

      <p>
        By visiting our site and/ or purchasing something from us, you engage in
        our “Service” and agree to be bound by the following terms and
        conditions (“Terms of Service”, “Terms”), including those additional
        terms and conditions and policies referenced herein and/or available by
        hyperlink. These Terms of Service apply to all users of the site,
        including without limitation users who are browsers, vendors, customers,
        merchants, and/ or contributors of content.
      </p>

      <h2>SECTION 1 - ONLINE STORE TERMS</h2>
      <p>
        By agreeing to these Terms of Service, you represent that you are at
        least the age of majority in your state or province of residence, or
        that you are the age of majority in your state or province of residence
        and you have given us your consent to allow any of your minor dependents
        to use this site.
      </p>
      <p>
        You may not use our products for any illegal or unauthorized purpose nor
        may you, in the use of the Service, violate any laws in your
        jurisdiction (including but not limited to copyright laws).
      </p>
      <p>
        You must not transmit any worms or viruses or any code of a destructive
        nature.
      </p>
      <p>
        A breach or violation of any of the Terms will result in an immediate
        termination of your Services.
      </p>

      <h2>SECTION 2 - GENERAL CONDITIONS</h2>
      <p>
        We reserve the right to refuse service to anyone for any reason at any
        time.
      </p>
      <p>
        You understand that your content may be transferred across networks and involve (a)
        transmissions over various networks; and (b) changes to conform and
        adapt to technical requirements of connecting networks or devices.
        Payment information is handled by our hosted payment provider.
      </p>
      <p>
        You agree not to reproduce, duplicate, copy, sell, resell or exploit any
        portion of the Service, use of the Service, or access to the Service or
        any contact on the website through which the service is provided,
        without express written permission by us.
      </p>
      <p>
        The headings used in this agreement are included for convenience only
        and will not limit or otherwise affect these Terms.
      </p>

      <h2>SECTION 3 - ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION</h2>
      <p>
        We are not responsible if information made available on this site is not
        accurate, complete or current. The material on this site is provided for
        general information only and should not be relied upon or used as the
        sole basis for making decisions without consulting primary, more
        accurate, more complete or more timely sources of information. Any
        reliance on the material on this site is at your own risk.
      </p>
      <p>
        This site may contain certain historical information. Historical
        information, necessarily, is not current and is provided for your
        reference only. We reserve the right to modify the contents of this site
        at any time, but we have no obligation to update any information on our
        site. You agree that it is your responsibility to monitor changes to our
        site.
      </p>

      <h2>SECTION 4 - MODIFICATIONS TO THE SERVICE AND PRICES</h2>
      <p>Prices for our products are subject to change without notice.</p>
      <p>
        We reserve the right at any time to modify or discontinue the Service
        (or any part or content thereof) without notice at any time.
      </p>
      <p>
        We shall not be liable to you or to any third-party for any
        modification, price change, suspension or discontinuance of the Service.
      </p>

      <h2>SECTION 5 - PRODUCTS OR SERVICES</h2>
      <p>
        Certain products or services may be available exclusively online through
        the website. These products or services may have limited quantities and
        are subject to return or exchange only according to our Return Policy.
      </p>
      <p>
        We have made every effort to display as accurately as possible the
        colors and images of our products that appear at the store. We cannot
        guarantee that your computer monitor's display of any color will be
        accurate. Please note that many of the products we sell are hand made,
        and can vary in size, shape, and colour. Please note that being a
        natural material, the tone and grain of any timber products will vary
        from one product to another. Timber can swell and shrink in response to
        its climate. We recommend not leaving any product in water for long
        periods, nor exposing to a heat source.
      </p>

      <h2>SECTION 6 - ACCURACY OF BILLING AND ACCOUNT INFORMATION</h2>
      <p>
        We reserve the right to refuse any order you place with us. We may, in
        our sole discretion, limit or cancel quantities purchased per person,
        per household or per order. These restrictions may include orders placed
        by or under the same customer account, the same payment method, and/or
        orders that use the same billing and/or shipping address.
      </p>

      <h2>SECTION 7 - OPTIONAL TOOLS</h2>
      <p>
        We may provide you with access to third-party tools over which we
        neither monitor nor have any control nor input.
      </p>

      <h2>SECTION 8 - THIRD-PARTY LINKS</h2>
      <p>
        Certain content, products and services available via our Service may
        include materials from third-parties.
      </p>

      <h2>SECTION 9 - USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS</h2>
      <p>
        If, at our request, you send certain specific submissions or without a
        request from us you send creative ideas, suggestions, proposals, plans,
        or other materials, you agree that we may, at any time, without
        restriction, edit, copy, publish, distribute, translate and otherwise
        use in any medium any comments that you forward to us.
      </p>

      <h2>SECTION 10 - PERSONAL INFORMATION</h2>
      <p>
        Your submission of personal information through the store is governed by
        our Privacy Policy.
      </p>

      <h2>SECTION 11 - ERRORS, INACCURACIES AND OMISSIONS</h2>
      <p>
        Occasionally there may be information on our site or in the Service that
        contains typographical errors, inaccuracies or omissions that may relate
        to product descriptions, pricing, promotions, offers, product shipping
        charges, transit times and availability. We reserve the right to correct
        any errors, inaccuracies or omissions.
      </p>

      <h2>SECTION 12 - PROHIBITED USES</h2>
      <p>
        In addition to other prohibitions as set forth in the Terms of Service,
        you are prohibited from using the site or its content for any unlawful
        purpose.
      </p>

      <h2>SECTION 13 - DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY</h2>
      <p>
        We do not guarantee, represent or warrant that your use of our service
        will be uninterrupted, timely, secure or error-free.
      </p>

      <h2>SECTION 14 - INDEMNIFICATION</h2>
      <p>
        You agree to indemnify, defend and hold harmless autumncircle and our
        parent, subsidiaries, affiliates, partners, officers, directors, agents,
        contractors, licensors, service providers, subcontractors, suppliers,
        interns and employees.
      </p>

      <h2>SECTION 15 - SEVERABILITY</h2>
      <p>
        In the event that any provision of these Terms of Service is determined
        to be unlawful, void or unenforceable, such provision shall nonetheless
        be enforceable to the fullest extent permitted by applicable law.
      </p>

      <h2>SECTION 16 - TERMINATION</h2>
      <p>
        The obligations and liabilities of the parties incurred prior to the
        termination date shall survive the termination of this agreement for all
        purposes.
      </p>

      <h2>SECTION 17 - ENTIRE AGREEMENT</h2>
      <p>
        The failure of us to exercise or enforce any right or provision of these
        Terms of Service shall not constitute a waiver of such right or
        provision.
      </p>

      <h2>SECTION 18 - GOVERNING LAW</h2>
      <p>
        These Terms of Service and any separate agreements whereby we provide
        you Services shall be governed by and construed in accordance with the
        laws of Hong Kong.
      </p>

      <h2>SECTION 19 - CHANGES TO TERMS OF SERVICE</h2>
      <p>
        You can review the most current version of the Terms of Service at any
        time at this page.
      </p>

      <h2>SECTION 20 - CONTACT INFORMATION</h2>
      <p>
        Questions about the Terms of Service should be sent to us at{" "}
        <a href="mailto:west@autumncircle.website">west@autumncircle.website</a>.
        Our business address is RM 10D R1, 10/F, KIN GA IND BUILDING, 9 SAN ON STREET, TUEN MUN, HONG KONG.
      </p>

      <div className="terms__back">
        <Link onClick={toTop} to="/">
          <span className="arrow">←</span> BACK TO HOME
        </Link>
      </div>
    </div>
  );
}

export default Terms;
